import FormLabel from 'general/components/Forms/FormLabel'
import InputNumberNoFormik from 'general/components/Forms/InputNumerNoFormik'

function TableHospitalInfo(props) {
  const { formik } = props
  const inputs = [
    {
      label: 'Tổng chi trả: ',
      systemConfigType: 'totalCost',
      name: 'totalPayableAmount',
    },
    {
      label: 'BHYT chi trả:',
      systemConfigType: 'totalCost',
      name: 'healthInsuranceCoveredAmount',
    },
    {
      label: 'Tạm ứng: ',
      systemConfigType: 'totalCost',
      name: 'advanceAmount',
    },
    {
      label: 'Miễn: ',
      systemConfigType: 'totalCost',
      name: 'patientExemptedAmount',
    },
    {
      label: 'Thu thêm: ',
      systemConfigType: 'totalCost',
      name: 'patientPaidAdditionalAmount',
    },

    {
      label: 'Chi phí coronavirus Real-time PCR: ',
      systemConfigType: 'totalCost',
      name: 'coronavirusPcrTestCost',
    },
    {
      label: 'Chi phí covid-19: ',
      systemConfigType: 'totalCost',
      name: 'covid19TreatmentCost',
    },
  ]

  return (
    <div className="row mt-5">
      {inputs.map((input, key) => {
        return (
          <div key={key} className="col-6 row">
            <div className="col-6">
              <FormLabel maxWidth="250px">{input.label}</FormLabel>
            </div>
            <div className="col-6">
              <InputNumberNoFormik
                systemConfigType={input.systemConfigType}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/[^\d-]/g, '') // Loại bỏ dấu phân cách
                  const numericValue = rawValue ? parseInt(rawValue, 10) : ''
                  formik.setFieldValue(input.name, numericValue)
                }}
                value={formik?.values?.[input.name]}
                textAlign={'center'}
                fixedDecimalScale={false}
                allowNegative={true}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default TableHospitalInfo
